module.exports = __webpack_public_path__ + "media/dingdong.da019738.mp3";